export default __webpack_public_path__ + "static/media/expl_gradcam_12_DE.4761dbf8.png";